export const zapisnik_povrat= {
    templateId: 81,
    category: 8,
    templateTitle: 'Zapisnik pri povratu instrumenta osiguranja plaćanja',
    templateDescription: `<p>Kako bi se adekvatno pratilo navedeno osjetljivo područje, primopredaja instrumenta osiguranja plaćanja obavlja se zapisnički.</p>`,
    description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Kao i zapisnik o predaji sredstava osiguranja, tako i zapisnik o povratu sredstava osiguranja predstavlja dobru praksu u poslovanju.</p>
    <p>Uz početnu predaju sredstava osiguranja plaćanja uz zapisnik, povrat sredstava osiguranja plaćanja uz zapisnik osigurava izdavatelja instrumenta osiguranja plaćanja od neželjenih manipulacija i neovlaštenih uporaba na njegovu štetu. </p> 

    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Neovjeravanje mjeničnog očitovanja kod javnog bilježnika - za bjanko mjenice</strong></p>
    <p>Pojašnjenje: bjanko mjenica nije mjenica već papir koji će tek postati mjenica ako i kad bude ispunjena u skladu sa zakonom. Bjanko mjenica nije mjenica jer ne sadrži sve sastojke mjenice, a ista nije niti pojmovno propisana zakonom, no i dalje ima značaj u poslovanju. Kod izdavanja bjanko mjenice izdavatelj, odnosno trasant, mora ovlastiti imatelja bjanko mjenice
    da ispuni potrebni sadržaj mjenice te će nakon ispunjavanja mjenica imati sve značajke mjenice. Navedeno ovlaštenje daje se putem mjeničnog očitovanja koje je nužno s obzirom na navedeno, pri čemu je potpis izdavatelja na mjeničnom očitovanju potrebno ovjeriti kod javnog bilježnika. </p>
    `,
    

    sides: [
        {
            signature: 'Za Predavatelja:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
          ],
            suffix: ' (u daljnjem tekstu: Predavatelj)',
            delimiter: `i`
        },
        {
            signature: 'Za Preuzimatelja:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
        ],
            suffix: ' (u daljnjem tekstu: Preuzimatelj),'
        }
    ],

 
    headline: "potpisuju sljedeći",
    title: 'ZAPISNIK PRI POVRATU INSTRUMENTA OSIGURANJA PLAĆANJA',
    noArticleNumbers: true,

    articles: [
     
        {
            title: '',
            mandatory: true,
            dummy: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Ovim zapisnikom Predavatelj vrši povrat, a Preuzimatelj preuzima instrument osiguranja plaćanja naveden u ovom Zapisniku.',
                    value: '',
                },
            ],
            value: '',
        },
     {
            title: "",
            mandatory: false,
            dummy: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  { type: "text", content: "Vrsta i naziv instrumenta osiguranja plaćanja:" },
                  { type: "textarea", value: "", required: true, help: "Ovdje upisujete vrstu i naziv instrumenta osiguranja plaćanja - npr. bjanko zadužnice na iznos do 50.000,00, vlastitu bjanko akceptiranu mjenicu po viđenju s naznakom „bez protesta“ (broj mjenice: 12604927, SERIJA A) sl.." },  
                ],
              }
            ]
          },
          {
            title: '',
            mandatory: false,
            dummy: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {
                            type: 'text',
                            content: 'Broj ovjere instrumenta osiguranja plaćanja/mjeničnog očitovanja'},
                            {type: 'input', value: '', required: true, help: 'Ukoliko je izdana zadužnica/bjanko zadužnica, upisujete broj ovjere na navedenim dokumentima, a ukoliko je izdana bjanko mjenica (mjenica u kojoj vjerovnik sam upisuje potrebne podatke koji se odnose na svotu, dospijeće i sl.) upisujete broj ovjere mjeničnog očitovanja.'},
                        {type: 'text', content: '​,'},
                        {type: 'text', content: 'ovjeren pri javnom bilježniku'},
                        {type: 'input', value: '', required: true,},
                        {type: 'text', content: '​,'},
                        {type: 'text', content: 'dana'},
                        {type: 'input', value: '', required: true,},
                        {type: 'text', content: 'godine.'},
                      ],
                }],
        },
          {
            title: "",
            mandatory: false,
            dummy: true,
            statements: [
              {
                type: "choice",
                mandatory: true,
                editable: false,
                choices: [
                    {
                        parts: [
                          { type: "text", content: "Instrument osiguranja plaćanja izdan je na iznos" },
                          { type: "input", value: "",  required: true },
                          { help: "Upišite iznos na koji je izdan instrument osiguranja plaćanja.", },  
                        ]
                      },
                {
                    parts: [
                      { type: "text", content: "Instrument osiguranja plaćanja (mjenica) je izdan bjanko - bez iznosa." },
                      { help: "Samo mjenice mogu biti izdane bez unosa ikakvog iznosa na koji instrument osiguranja plaćanja glasi.", required: true },
                    ]
                  },
                
                ],
              }
            ]
          },
              {
          title: "",
          mandatory: false,
          dummy: true,
          statements: [
            {
              type: "input",
              mandatory: true,
              parts: [
                { type: "text", content: "Instrument osiguranja plaćanja je Predavatelj prethodno zaprimio od Preuzimatelja dana" },
                { type: "input", value: "", required: true, help: "Unesite datum kada je instrument osiguranja plaćanja prethodno predan."},
                { type: "input", value: "", required: true, help: "Unesite način predaje, npr. neposrednom predajom ili npr. uz zapisnik o predaji instrumenta osiguranja plaćanja od datuma xy.xy.xyxy. godine"}, 
              ],
            }
          ]
        }, 
        {
            title: '',
            mandatory: false,
            dummy: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {
                            type: 'text',
                            content: 'Primopredaja (povrat) instrumenta osiguranja plaćanja izvršena je u'
                        },
                        {
                            type: 'input',
                            value: '',
                            placeholder: "Upišite mjesto.",
                            required: true
                        },
                        {
                            type: 'text',
                            content: ', dana'
                        },
                        {
                          type: 'input',
                          value: '',
                          placeholder: "Upišite datum.",
                          required: true
                      },
                        {
                            type: 'text',
                            content: 'godine.'
                        }
                    ]
                },
            ]
        },
      
        {
          title: '',
          mandatory: false,
          dummy: true,
          statements: [
              {
                  type: 'text',
                  required: false,
                  mandatory: true,
                  editable: true,
                  content: 'Ovaj Zapisnik sastavljen je u 2 (dva) primjerka, od kojih svaka strana zadržava po 1 (jedan) primjerak.',
                  value: '',
              }],
        },
                {
                    mandatory: true,
                    static: true,
                    type: 3,  // signatures
                    statements: [],
                },
            ],
};












// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/81_zapisnik_povrat.ts